import Header from './header/header';
import Footer from './footer/footer';
import Mobile from './step-2/mobile';
import Otp from './step-2/otp';
import AddTickets from './step-2/addTickets';
import Slider from './step-2/slider';
import BreakupDetails from './step-2/breakupDetails';
import Tickets from './step-2/tickets';
import AddTicketDetails from './step-2/addTicketDetails';
import DeleteModal from './step-2/deleteModal';


export {
  Header,
  Footer,
  Mobile,
  Otp,
  AddTickets,
  Slider,
  BreakupDetails,
  Tickets,
  AddTicketDetails,
  DeleteModal,
};